const Collab = {
  GET_CONFIG: 'GET_CONFIG',
  GET_CONFIG_SUCCESS: 'GET_CONFIG_SUCCESS',
  GET_CONFIG_FAILURE: 'GET_CONFIG_FAILURE',
}
export { Collab }